export default __webpack_public_path__ + "static/media/My_orders_header.4aeeba5d.svg";